import { Component } from "@angular/core";

@Component({
    standalone: true,
    selector: "ruts-maintenance",
    templateUrl: "./maintenance.component.html",
    styleUrls: ["./maintenance.component.scss"],
})
export class MaintenanceComponent {}
